<template>
  <div>
    <h4>Contenidos esperados en la colaboración</h4>
    <p class="avenir-medium">La invitación en esta campaña busca colaborar con los siguientes contenidos contigo:</p>

    <div class="summary-container d-flex align-items-center mb-2">
      <div><feather-icon icon="InfoIcon" size="30" class="mr-1"/></div>
      <div>
        <h4 class="d-block mb-1">{{ $t('invitation.suggestionContent') }}</h4>
        <span>{{ $t('invitation.suggestionText') }}</span>
      </div>
    </div>

    <b-col>
      <b-row class="" v-if="loaded_contents">
        <b-col v-for="(item, index) in items" :key="index" class="border mb-2 p-0 col-12">
          <div class="d-flex align-items-center p-1 cursor-pointer" @click="showDetails(item.actions)">
            <b-avatar size="35" variant="ligth" class="m-1">
              <b-img
                :src="getIconWhite(item.content_type.network)"
                :class="getIconColor(item.content_type.network, false)"
                fluid
              />
            </b-avatar>
            <div class="flex-grow-1">
              <strong>
                {{$t(`invitation.${item.content_type.network}`)}}
              </strong>
              <strong class="d-block mt-1">
                {{ $t('invitation.contentType') }}: {{getContentType(item.actions)}}
              </strong>
            </div>
            <!-- Aviso de colaboración pendiente en YouTube Studio -->
            <div
              v-if="item.actions.deal && item.actions.deal.status === 'pending' && item.actions.deal.url_youtube_studio"
              class="ml-auto mr-1 flex-shrink-0"
              @click.stop
            >
              <feather-icon
                :id="`yt-pending-${index}`"
                icon="AlertCircleIcon"
                size="20"
                class="text-warning cursor-pointer"
              />
              <b-popover
                :target="`yt-pending-${index}`"
                triggers="hover focus"
                placement="left"
                boundary="window"
                custom-class="popover-warning-header"
              >
                <template #title>
                  <span class="font-weight-bold" style="font-size:0.85rem">
                    {{ $t('invitation.youtubePendingApprovalTitle') }}
                  </span>
                </template>
                <p class="mb-1" style="font-size:0.82rem">
                  {{ $t('invitation.youtubePendingApprovalBody') }}
                </p>
                <b-link
                  :href="item.actions.deal.url_youtube_studio"
                  target="_blank"
                  class="d-inline-flex align-items-center font-weight-bold"
                  style="font-size:0.82rem"
                >
                  {{ $t('invitation.youtubePendingApprovalLink') }}
                  <feather-icon icon="ExternalLinkIcon" size="11" class="ml-25"/>
                </b-link>
              </b-popover>
            </div>
          </div>
          <div class="button-box-color-gray p-1 border-top">
            <b-button size="sm" class="mr-1 mb-1 mb-sm-0" variant="outline-secondary" @click="showDetails(item.actions)">
              <feather-icon icon="EditIcon" size="18"/>
              {{$t('invitation.uploadContent')}}
            </b-button>
            <b-button size="sm" class="blue-button-new mb-1 mb-sm-0"  variant="blue-button-new" @click="openModalContent(item.actions)" v-if="showButtonContent(item.actions)">
              <feather-icon icon="EyeIcon" size="18"/>
              {{$t('campaigns.watch_content')}} 
            </b-button>
          </div>
        </b-col>
        <b-pagination
          class="d-flex justify-content-center mt-1 w-100"
          v-model="current_page"
          :total-rows="campaign.total_contents"
          :per-page="per_page"
          v-if="items.length > 0"
        ></b-pagination>
        <b-col v-if="items.length === 0" class="mt-5">
          <div class="no-content text-center">{{$t('invitation.no_content')}}</div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col v-for="(item, index) in 3" :key="index" class="border mb-2 p-0 col-12">
          <div class="d-flex p-1 cursor-pointer">
            <b-skeleton type="avatar" size="35" variant="ligth" class="m-1"></b-skeleton>
            <div>
              <b-skeleton width="100px"></b-skeleton>
              <b-skeleton width="200px"></b-skeleton>
            </div>
          </div>
          <div class="button-box-color-gray p-1 border-top">
            <b-skeleton type="button" width="300px"></b-skeleton>
          </div>
        </b-col>
      </b-row>       
    </b-col>
   
    <b-sidebar
      right
      v-model="sidebar_details"
      backdrop-variant="dark"
      no-header-close
      backdrop
      shadow
      width="500px"
      body-class="m-1"
      bg-variant="white"
      v-if="show_details_content"
    >
      <template #header>
        <div class="header-sidebar d-flex mt-2 px-1">
          <b-avatar size="35" variant="ligth" class="mr-1">
            <b-img 
              :src="getIconWhite(show_details_content.network)"
              :class="getIconColor(show_details_content.network, false)"
              fluid
            />
          </b-avatar>  
          <div class="d-flex flex-column">
            <span class="title mb-0">{{$t(`invitation.${show_details_content.network}`)}} #{{show_details_content.index}}</span>
            <span class="d-block ">
                {{ $t('invitation.contentType') }}: {{getContentType(show_details_content)}}
            </span>
          </div>
          <feather-icon
              class="close-component close-right"
              icon="XIcon"
              size="16"
              @click="closeSidebar"
          />
        </div>
      </template>
      <details-content 
        :key="change_detail_content" 
        @closeSidebar="closeSidebar" 
        :content="show_details_content" 
        :campaign="campaign" 
        v-if="sidebar_details"
        @updateContent="updateContent"
      />
    </b-sidebar>
    <modal-content 
      :open_modal="open_modal_content"
      :asset_url="verifyAsset(asset_modal)" 
      :type_content="content_type_modal"
      @close_modal="open_modal_content = false"
      :download="can_download"
      :key="update_modal_content"
    />
  </div>
</template>

<script>
import { BButton, BPagination, BImg, BCol, BRow, BSidebar, BAvatar, BSkeleton, BPopover, BLink } from 'bootstrap-vue';
import { getDatev2 } from "@/libs/utils/times";
import { getDropdownNetworks, getIconWhite, getIconColor } from '@/libs/utils/icons'
import detailsContent from '@/views/pages/invitation/newInvitation/detailsContent.vue';
import { verifyAsset } from '@/libs/utils/urls'
import invitation_service from "@/services/invitation";

export default {
  data() {
    return {
      verifyAsset,
      getIconColor,
      getIconWhite,
      getDatev2,
      getDropdownNetworks,
      contents: [],
      campaign_uuid: '',
      campaign_influencer: '',
      items: [],
      current_page: 1,
      per_page: 10,
      can_download: false,
      sidebar_details: false,
      show_details_content: null,
      change_detail_content: false,
      open_modal_content: false,
      content_type_modal: '',
      asset_modal: '',
      update_modal_content: false,
      loaded_contents: false,
    };
  },
  components: {
    ModalContent: () => import('@/views/components/modal/ModalContent.vue'),
    BAvatar,
    BSkeleton,
    BPagination,
    BButton,
    BImg,
    BCol,
    BRow,
    BSidebar,
    BPopover,
    BLink,
    detailsContent,
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
  },
  created() {
    this.campaign_uuid = this.campaign.uuid;
    this.campaign_influencer = this.campaign.campaign_influencer.uuid
    this.getContents();    
  },

  methods: {
    getContents() {
      const campaign_influencer_uuid = this.campaign.campaign_influencer.uuid;
      invitation_service.contents(campaign_influencer_uuid, this.current_page, this.per_page).then((response) => {
        this.contents = response.results;
        this.campaign.total_contents = response.count;
        this.getContentsTable();
      });
    },
    openModalContent(content) {
      if (content.content_type !== 'story') {
        if (content.url_info) {
          window.open(content.url_info, '_blank')
        } else if (content.image_content) {
          window.open(content.image_content, '_blank')
        }
      } else {
        this.open_modal_content = true;
        this.asset_modal = content.image_content;
        this.content_type_modal = content.image_content_url ? 'video' : 'image';
        this.update_modal_content = !this.update_modal_content
        this.can_download = true
      }
    },
    updateContent(data) {
      const new_contents = this.contents.map((item) => {
        if (item.uuid === data.uuid) item = data;
        return item;
      });
      this.contents = new_contents;
      this.getContentsTable();
    },
    closeSidebar() {
      this.sidebar_details = false
      this.show_details_content = null
      this.change_detail_content = !this.change_detail_content
    },
    showDetails(data) {
      this.sidebar_details = true
      this.show_details_content = data
      this.change_detail_content = !this.change_detail_content
    },
    getContentType(content) {
      if (content.network === 'tiktok' && content.content_type === 'reel') return this.$t(`invitation.videoVertical`)
      if (content.network === 'blog' && content.content_type === 'post') return 'Blog Post'
      if (content.network === 'snapchat' && content.content_type === 'reel') return 'Spotlight'
      return this.$t(`invitation.${content.content_type}`)
    },
    formatDate(date_string, has_timezone = false) {
      if (!date_string) return '-'
      const date = new Date(date_string)
      if (!has_timezone) date.setDate(date.getDate())
      return getDatev2(date)
    },
    showButtonContent(content) {
      return content.url_info || content.image_content
    },
    getContentsTable() {
      this.items = [];
      this.contents.forEach((element, index) => {
        element.index = index + 1
        this.items.push({ID: element.id, content_type: {content_type: element.content_type,  network: element.network}, published_date: element.published_date, last_update:element.updated_at, actions: element})
      })
      setTimeout(() => {
        this.loaded_contents = true;
      }, 300);
    },
  },
  watch: {
    current_page() {
      this.getContents();
    },
  },
};
</script>
<style scoped lang="scss">
.summary-container {
  background-color: #e9f0fc;
  padding: 1rem;
  border-radius: 0.5rem;
  color: #444050;

  svg {
    color: #8d86a3;
  }
}
</style>
<style>
.popover.popover-warning-header {
  border: none !important;
  outline: none !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15) !important;
  border-radius: 6px !important;
  overflow: hidden !important;
}
.popover.popover-warning-header .popover-header {
  background-color: #ff9f43 !important;
  color: #fff !important;
  border: 1px solid #ff9f43 !important;
  border-radius: 0 !important;
}
.popover.popover-warning-header .popover-body {
  border-top: none !important;
}
.popover.popover-warning-header .arrow::before {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.popover.popover-warning-header .arrow::after {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
}
.no-content {
  font-size: 30px;
  color: rgb(180, 180, 180);
}
.dropdown-disabled {
  border: 1px solid #D8D6DE;
  padding: 0.4em;
  border-radius: 0.3em;
}
.mr-05 { 
  margin-right:5px;
}
.dropdownNet{
  border: 1px solid #D8D6DE;
  /* padding: 0.4em; */
  border-radius: 0.3em;
}
.dropdownNet:focus-within{
  border: none;
  border: 1px solid #7367F0;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;  
}
.icon-networks-connected {
  font-size: 21px;
  color: #fff !important;
  padding: 10px;
}
.submenu {
  margin-top: 15em;
}

.content-type{
  font-size: 20px;
  margin-right: 10px;
  color:#7367F0;
}

.button-edit{ 
  color: #7367F0;
  border-color: #7367F0;
  margin-right: 10px;
}
.button-edit:hover{ 
  background-color: #e7e5ff ;
  color: #7367F0;
  border-color: #7367F0;
  margin-right: 10px;
}
.text-center-modal{
  margin-left: 135px;
}
.button-box-color-gray {
  background-color: #FAFAFA;
}
.header-sidebar {
  font-size: 1rem;
}
.header-sidebar .title{
  font-size: 14px;
  font-weight: 900;
}
.close-right {
  position: absolute;
  right: 50px;
}
</style>